import React, { Component } from 'react'
import { Link } from "gatsby"
import { graphql } from 'gatsby'

import Layout from "./layout"
import Image from "./image"
import SEO from "./seo"

export default class projectsLayout extends Component {
    render() {
        const { markdownRemark } = this.props.data;

        
        return (
            <Layout>
              <div class="content-wrap">
                <section class="section project-info">
                  <h1 class="title"><Link to="/projects" className="go-back">&#8249; Verkefni</Link></h1>
                  <div className="about-us-columns">
                    <div className="text-column">
                      <p class="title is-1">{markdownRemark.frontmatter.title}</p>
                      <p class="subtitle is-5">{markdownRemark.frontmatter.location}</p>

                      <strong>Framkvæmdarár:</strong>
                      <p class="subtitle is-6" id="projects">{markdownRemark.frontmatter.performance_date}</p>

                      <strong>Verkkaupi:</strong>
                      <p class="subtitle is-6" id="projects">{markdownRemark.frontmatter.buyer}</p>


                      <span class="subtitle is-6" id="projects"><strong>Stærð húsnæðis:</strong> {markdownRemark.frontmatter.housing_size}</span>
                      <br></br>
                      <span class="subtitle is-6" id="projects"><strong>Stærð lóðar:</strong> {markdownRemark.frontmatter.plot_size}</span>           
                      <br></br>
                      <br></br>


                      <strong>Lýsing:</strong>
                      <p class="subtitle is-6" id="projects" dangerouslySetInnerHTML={{
                        __html: markdownRemark.html
                      }} ></p>
                      <br></br>
                      <br></br>

                      <strong>Hlutverk Strendings:</strong>
                      <p class="subtitle is-6" id="projects">{markdownRemark.frontmatter.role}</p>

                      {markdownRemark.frontmatter.tag.map(oneTag => (
                        <p className="tag is-primary space-tags">{oneTag}</p>
                      ))}

                    </div>
                    <div className="img-column">
                    <img class="image-of-project" src={markdownRemark.frontmatter.moreImage.childImageSharp.fluid.src} alt="Placeholder image"></img>
                    </div>
                  </div>
                </section>
              </div>
            </Layout>
        )
    }
}

export const query = graphql`
query ProjectQuery($slug: String!){
    markdownRemark(frontmatter: {
      path: {
        eq: $slug
      }
    }) {
      html
      frontmatter{
        title
        location
        performance_date
        buyer
        role
        tag
        housing_size
        plot_size
        moreImage {
          childImageSharp {
            fluid(maxWidth: 800) {
              src
            }
          }
        }
      }
    }
  }
`